module.exports = __webpack_public_path__ + "img/tech.aad9226e.jpg";